import React, { useState } from 'react';
import { MapPin, Phone, Mail, Instagram, Clock, Send } from 'lucide-react';
import { Seo } from '../components/Seo';
export function Contact() {
  return <div className="w-full" data-id="element-351" data-mp="1bugj7ke9bial">
      <Seo title="Contact and Directions | Reach Performance McKinney" description="Reach Performance trains inside INPOWERiQ Performance Center at 6051 Alma Rd, McKinney, TX 75070. Call, text, or send a message to Coach Fernando." path="/contact" data-id="element-352" data-mp="1qpwbbjva144c" />
      <SplitInfo data-id="element-353" data-mp="t1uoj3f35xrl" />
      <ContactForm data-id="element-354" data-mp="t2dv5nzaczqb" />
    </div>;
}
/* ---------- 1. SPLIT INFO + MAP ---------- */
function SplitInfo() {
  return <section className="bg-white" data-id="element-355" data-mp="17rk0zusmpo76">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[680px]" data-id="element-356" data-mp="17slh4doi50vr">
        {/* Left — info */}
        <div className="flex flex-col justify-center px-6 md:px-12 lg:px-16 py-16 lg:py-20 bg-white relative overflow-hidden" data-id="element-357" data-mp="fa7rv2h8en8a">
          {/* Red speed streak accent */}
          <div className="absolute -top-1 left-0 w-28 h-1.5 bg-reach-red" data-id="element-358" data-mp="aauuvownbzrz" />

          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-4" data-id="element-359" data-mp="15enijemnxru3">
            Visit · Call · Train
          </p>
          <h1 className="font-bebas text-reach-black text-6xl md:text-7xl lg:text-[88px] leading-[0.9] tracking-wide mb-8" data-id="element-360" data-mp="1e7qqj7ejhchc">
            Where to
            <br data-id="element-361" data-mp="1j5iks82npaop" />
            Find Us
          </h1>

          <div className="w-12 h-1 bg-reach-red mb-8" data-id="element-362" data-mp="mgkqss2qdgsl" />

          {/* New Portrait Card */}
          <div className="mb-10 bg-reach-black p-6 rounded-[4px] max-w-[248px]" data-id="element-363" data-mp="qi68cqq7mj94">
            <img src="https://cdn.magicpatterns.com/uploads/nS7CAkLSbDsg56k6ey7c7u/FernandoB_Dec2022-42-2.jpg" alt="Coach Fernando Beltran portrait" className="w-[200px] h-[200px] object-cover object-top rounded-[4px] mb-5" style={{
            filter: 'grayscale(0.4) contrast(1.15) saturate(0.7)'
          }} data-id="element-364" data-mp="qk8xz9ngaadb" />
            <p className="font-inter text-reach-red text-xs uppercase tracking-[0.2em] font-semibold mb-2" data-id="element-365" data-mp="2bto7h0d9t9r6">
              WHO READS THIS
            </p>
            <p className="font-inter text-white text-[18px] leading-snug" data-id="element-366" data-mp="1h922948ab6y7">
              Coach Fernando reads every message and personally responds.
            </p>
          </div>

          <ul className="space-y-6" data-id="element-367" data-mp="1r6pyjyljgmih">
            <li className="flex items-start gap-4" data-id="element-368" data-mp="1r7rlp1ftwzgk">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-369" data-mp="13gvn9lgvb60c">
                <MapPin size={18} className="text-reach-red" data-id="element-370" data-mp="yi176raabvjx" />
              </div>
              <a href="https://maps.google.com/?q=6051+Alma+Rd,+McKinney,+TX+75070" target="_blank" rel="noopener noreferrer" className="group" data-id="element-371" data-mp="yfy5vb3omfzw">
                <p className="font-inter text-reach-black text-xl md:text-2xl font-semibold leading-snug group-hover:text-reach-red transition-colors" data-id="element-372" data-mp="kpuoaxfqzags">
                  6051 Alma Rd · McKinney, TX 75070
                </p>
                <p className="font-inter text-sm text-reach-black/60 mt-1 uppercase tracking-wider" data-id="element-373" data-mp="2rdljbm9iku4y">
                  Inside INPOWERiQ Performance Center
                </p>
              </a>
            </li>

            <li className="flex items-center gap-4" data-id="element-374" data-mp="2hhs41v4eumjh">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-375" data-mp="2mfac7jalsxqf">
                <Phone size={18} className="text-reach-red" data-id="element-376" data-mp="3a4mjueqa8xqm" />
              </div>
              <a href="tel:7089804666" className="font-inter text-reach-black text-lg md:text-xl hover:text-reach-red transition-colors" data-id="element-377" data-mp="3f47gujlw6w0p">
                (708) 980-4666
              </a>
            </li>

            <li className="flex items-center gap-4" data-id="element-378" data-mp="354qby4egsm5s">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-379" data-mp="1ppj60msy9m4s">
                <Mail size={18} className="text-reach-red" data-id="element-380" data-mp="1tre65nz59tgz" />
              </div>
              <a href="mailto:Fernando@reachperformancehq.com" className="font-inter text-reach-black text-base md:text-lg hover:text-reach-red transition-colors break-all" data-id="element-381" data-mp="29y0v84ant9om">
                Fernando@reachperformancehq.com
              </a>
            </li>

            <li className="flex items-start gap-4" data-id="element-382" data-mp="1v94smmrdgove">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-383" data-mp="1vapl86u4lxqm">
                <Clock size={18} className="text-reach-red" data-id="element-384" data-mp="2swd8o28lt5q0" />
              </div>
              <div data-id="element-385" data-mp="2nz3k0ot1gy38">
                <p className="font-inter text-reach-black text-lg font-semibold" data-id="element-386" data-mp="2nyle10gkr5i4">
                  Monday to Friday
                </p>
                <p className="font-inter text-sm text-reach-black/60 uppercase tracking-wider mt-0.5" data-id="element-387" data-mp="2exdtdl6ze36i">
                  See class schedule
                </p>
              </div>
            </li>

            <li className="flex items-center gap-4" data-id="element-388" data-mp="13hyolv8j670u">
              <div className="w-10 h-10 bg-reach-black rounded flex items-center justify-center shrink-0" data-id="element-389" data-mp="13gdrpyyqubzt">
                <Instagram size={18} className="text-reach-red" data-id="element-390" data-mp="3f7552d8dzz7x" />
              </div>
              <a href="https://instagram.com/reachperformancehq" target="_blank" rel="noopener noreferrer" className="font-inter text-reach-black text-lg hover:text-reach-red transition-colors" data-id="element-391" data-mp="3j7oxj3i0menq">
                @reachperformancehq
              </a>
            </li>
          </ul>
        </div>

        {/* Right — map */}
        <div className="relative min-h-[400px] lg:min-h-0 bg-reach-black" data-id="element-392" data-mp="6o610nl2rtx9">
          <iframe title="Reach Performance location at 6051 Alma Rd, McKinney, TX" src="https://www.google.com/maps?q=6051%20Alma%20Rd%2C%20McKinney%2C%20TX%2075070&t=&z=15&ie=UTF8&iwloc=&output=embed" className="absolute inset-0 w-full h-full grayscale contrast-110" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-393" data-mp="aqu8ory1yusn" />
          {/* Subtle red accent bar */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-reach-red z-10 pointer-events-none" data-id="element-394" data-mp="3kspm9m5cv4v2" />
        </div>
      </div>
    </section>;
}
/* ---------- 2. CONTACT FORM ---------- */
type Status = 'idle' | 'submitting' | 'success' | 'error';
const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xgoqybwb';
function ContactForm() {
  const [status, setStatus] = useState<Status>('idle');
  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const data: Record<string, string> = {};
    formData.forEach((value, key) => {
      data[key] = value.toString();
    });
    setStatus('submitting');
    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        form.reset();
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  }
  const resetForm = () => setStatus('idle');
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-395" data-mp="v0er7wz5rban">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-396" data-mp="zzhy7myp7rl9">
        <div className="text-center mb-10" data-id="element-397" data-mp="zy6l2wjd57hh">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-398" data-mp="m833iivfi1yd">
            Get In Touch
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none" data-id="element-399" data-mp="r0w9tb6jpick">
            Have a Question?
          </h2>
          <p className="font-inter text-reach-black/70 text-base md:text-lg mt-4 max-w-xl mx-auto" data-id="element-400" data-mp="h9jeuapgac2b">
            Send us a note. Coach Fernando reads every message.
          </p>
        </div>

        <div className="bg-white rounded-[4px] p-6 md:p-10 border-t-4 border-reach-red" data-id="element-401" data-mp="3c4liuw2tk52">
          {status === 'success' ? <div className="text-center py-10" data-id="element-402" data-mp="nrei70mi047h">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-403" data-mp="nq3d8xhbgqes">
                <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-404" data-mp="ipp75kz9zqje">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-405" data-mp="4t25x60aie7o" />
                </svg>
              </div>
              <h3 className="font-bebas text-3xl md:text-4xl tracking-wide mb-3" data-id="element-406" data-mp="3r5h3xla6j1wz">
                Thanks, your message is in
              </h3>
              <p className="font-inter text-reach-black/75 max-w-md mx-auto mb-6" data-id="element-407" data-mp="3h9nl5k5vac6r">
                Coach Fernando typically responds within 24 hours.
              </p>
              <button type="button" onClick={resetForm} className="inline-flex items-center justify-center font-inter font-semibold text-sm uppercase tracking-wider px-5 py-2.5 border-2 border-reach-black text-reach-black rounded hover:bg-reach-black hover:text-white transition-colors" data-id="element-408" data-mp="1sprvqp2cf63u">
                Send another
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-409" data-mp="192k61v3r2eag">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-410" data-mp="1e0vfi4q4ums5">
                <Field id="name" label="Name" required type="text" autoComplete="name" placeholder="Your name" data-id="element-411" data-mp="1e157tyynh610" />
                <Field id="email" label="Email" required type="email" autoComplete="email" placeholder="you@example.com" data-id="element-412" data-mp="qbki8x7zrair" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-413" data-mp="ozor9ws4jtxx">
                <Field id="phone" label="Phone" type="tel" autoComplete="tel" placeholder="(555) 123-4567" data-id="element-414" data-mp="tvds03fvrgvt" />
                <div data-id="element-415" data-mp="13u3de66zjjgt">
                  <label htmlFor="interest" className="block font-inter text-xs uppercase tracking-[0.2em] font-semibold text-reach-black mb-2" data-id="element-416" data-mp="13sigwb141qgb">
                    What are you asking about
                  </label>
                  <select id="interest" name="interest" autoComplete="off" className="w-full px-4 py-3 min-h-[48px] bg-white border-2 border-black/25 rounded font-inter text-base text-reach-black focus:outline-none focus:border-reach-red transition-colors" data-id="element-417" data-mp="g3z8zwlz3for">
                    <option value="" data-id="element-418" data-mp="25q93iajlgidd">Select a topic</option>
                    <option value="advanced-performance" data-id="element-419" data-mp="25nmx4e8fw8wq">
                      Advanced Performance, high school
                    </option>
                    <option value="homeschool" data-id="element-420" data-mp="1wohxt5p20bji">Homeschool Multisport</option>
                    <option value="speed-school" data-id="element-421" data-mp="1rqgeqkrmoc81">Speed School</option>
                    <option value="private" data-id="element-422" data-mp="1rsap5559wlxv">Private or semi-private training</option>
                    <option value="pro-collegiate" data-id="element-423" data-mp="1mselx84egyjd">College or pro training</option>
                    <option value="other" data-id="element-424" data-mp="1hzlhymgr9u8c">Something else</option>
                  </select>
                </div>
              </div>

              <div data-id="element-425" data-mp="1dwp233iloc83">
                <label htmlFor="message" className="block font-inter text-xs uppercase tracking-[0.2em] font-semibold text-reach-black mb-2" data-id="element-426" data-mp="18zyqasdtw2sh">
                  Message
                </label>
                <textarea id="message" name="message" required rows={5} autoComplete="off" placeholder="What can we help with?" className="w-full px-4 py-3 bg-white border-2 border-black/25 rounded font-inter text-base text-reach-black focus:outline-none focus:border-reach-red transition-colors resize-none" data-id="element-427" data-mp="z2u0mikrxp6x" />
              </div>

              <button type="submit" disabled={status === 'submitting'} className="btn-primary w-full sm:w-auto disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-428" data-mp="1844t1jzkl8gp">
                <Send size={16} className="mr-2" data-id="element-429" data-mp="zbbbth0kbz07" />
                {status === 'submitting' ? 'Sending' : 'Send'}
              </button>

              <p aria-live="polite" data-id="element-430" data-mp="13bbpv0jr286q">
                {status === 'error' && <span className="block font-inter text-sm text-red-700" data-id="element-431" data-mp="1r1zbeoml8wbr">
                    Something went wrong. Please email
                    Fernando@reachperformancehq.com or call 708-980-4666.
                  </span>}
              </p>
            </form>}
        </div>

        <p className="text-center font-inter text-xs uppercase tracking-[0.25em] text-reach-black/50 mt-8" data-id="element-432" data-mp="3bj8ic9fbztu5">
          We typically respond within 24 hours
        </p>
      </div>
    </section>;
}
function Field({
  id,
  label,
  type,
  placeholder,
  required,
  autoComplete
}: {
  id: string;
  label: string;
  type: string;
  placeholder?: string;
  required?: boolean;
  autoComplete?: string;
}) {
  return <div data-id="element-433" data-mp="2sothee9glr3o">
      <label htmlFor={id} className="block font-inter text-xs uppercase tracking-[0.2em] font-semibold text-reach-black mb-2" data-id="element-434" data-mp="37jpt51gh8wli">
        {label}
        {required && <span className="text-reach-red ml-1" data-id="element-435" data-mp="32mzhqrfmap6f">*</span>}
      </label>
      <input id={id} name={id} type={type} placeholder={placeholder} required={required} autoComplete={autoComplete} className="w-full px-4 py-3 min-h-[48px] bg-white border-2 border-black/25 rounded font-inter text-base text-reach-black placeholder:text-reach-black/60 focus:outline-none focus:border-reach-red transition-colors" data-id="element-436" data-mp="ms5zzsz0cgxp" />
    </div>;
}